import { Tag } from "./Tag";
import type { CompassDir } from "../lib/types";
import styles from "./DetailPageSpotHeader.module.css";

interface DetailPageSpotHeaderProps {
  area: string;
  name: string;
  idealDirs: readonly CompassDir[];
}

/**
 * Header on the detail page — area + spot name on the left, "Best in"
 * label + direction tags on the right. Bottom border-faint divider.
 * Figma node 103:19611.
 */
export function DetailPageSpotHeader({
  area,
  name,
  idealDirs,
}: DetailPageSpotHeaderProps) {
  // No ideal directions = custom dropped pin (no curation). Skip the
  // right-side "Best in" column entirely rather than showing an empty
  // label that would just confuse the user.
  return (
    <div className={styles.spotHeader}>
      <div className={styles.location}>
        <span className={styles.area}>{area}</span>
        <h1 className={styles.name}>{name}</h1>
      </div>
      {idealDirs.length > 0 && (
        <div className={styles.worksBest}>
          <span className={styles.worksBestLabel}>Best in</span>
          <div className={styles.worksBestTags}>
            {idealDirs.map((d) => (
              <Tag key={d}>{d}</Tag>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
